import { purchaseOrderIdFormat } from "@redotech/redo-inventory-id";
import * as z from "zod";

export const bulkDeletePurchaseOrders = {
  name: "bulkDeletePurchaseOrders" as const,
  input: z.object({ purchaseOrderIds: z.array(purchaseOrderIdFormat.schema) }),
  output: z.object({ success: z.boolean() }),
};
